"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: miimosa/common/v1/month.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.monthToJSON = exports.monthFromJSON = exports.Month = void 0;
/* eslint-disable */
exports.Month = {
    MONTH_UNSPECIFIED: "MONTH_UNSPECIFIED",
    MONTH_JANUARY: "MONTH_JANUARY",
    MONTH_FEBRUARY: "MONTH_FEBRUARY",
    MONTH_MARCH: "MONTH_MARCH",
    MONTH_APRIL: "MONTH_APRIL",
    MONTH_MAY: "MONTH_MAY",
    MONTH_JUNE: "MONTH_JUNE",
    MONTH_JULY: "MONTH_JULY",
    MONTH_AUGUST: "MONTH_AUGUST",
    MONTH_SEPTEMBER: "MONTH_SEPTEMBER",
    MONTH_OCTOBER: "MONTH_OCTOBER",
    MONTH_NOVEMBER: "MONTH_NOVEMBER",
    MONTH_DECEMBER: "MONTH_DECEMBER",
    UNRECOGNIZED: "UNRECOGNIZED",
};
function monthFromJSON(object) {
    switch (object) {
        case 0:
        case "MONTH_UNSPECIFIED":
            return exports.Month.MONTH_UNSPECIFIED;
        case 1:
        case "MONTH_JANUARY":
            return exports.Month.MONTH_JANUARY;
        case 2:
        case "MONTH_FEBRUARY":
            return exports.Month.MONTH_FEBRUARY;
        case 3:
        case "MONTH_MARCH":
            return exports.Month.MONTH_MARCH;
        case 4:
        case "MONTH_APRIL":
            return exports.Month.MONTH_APRIL;
        case 5:
        case "MONTH_MAY":
            return exports.Month.MONTH_MAY;
        case 6:
        case "MONTH_JUNE":
            return exports.Month.MONTH_JUNE;
        case 7:
        case "MONTH_JULY":
            return exports.Month.MONTH_JULY;
        case 8:
        case "MONTH_AUGUST":
            return exports.Month.MONTH_AUGUST;
        case 9:
        case "MONTH_SEPTEMBER":
            return exports.Month.MONTH_SEPTEMBER;
        case 10:
        case "MONTH_OCTOBER":
            return exports.Month.MONTH_OCTOBER;
        case 11:
        case "MONTH_NOVEMBER":
            return exports.Month.MONTH_NOVEMBER;
        case 12:
        case "MONTH_DECEMBER":
            return exports.Month.MONTH_DECEMBER;
        case -1:
        case "UNRECOGNIZED":
        default:
            return exports.Month.UNRECOGNIZED;
    }
}
exports.monthFromJSON = monthFromJSON;
function monthToJSON(object) {
    switch (object) {
        case exports.Month.MONTH_UNSPECIFIED:
            return "MONTH_UNSPECIFIED";
        case exports.Month.MONTH_JANUARY:
            return "MONTH_JANUARY";
        case exports.Month.MONTH_FEBRUARY:
            return "MONTH_FEBRUARY";
        case exports.Month.MONTH_MARCH:
            return "MONTH_MARCH";
        case exports.Month.MONTH_APRIL:
            return "MONTH_APRIL";
        case exports.Month.MONTH_MAY:
            return "MONTH_MAY";
        case exports.Month.MONTH_JUNE:
            return "MONTH_JUNE";
        case exports.Month.MONTH_JULY:
            return "MONTH_JULY";
        case exports.Month.MONTH_AUGUST:
            return "MONTH_AUGUST";
        case exports.Month.MONTH_SEPTEMBER:
            return "MONTH_SEPTEMBER";
        case exports.Month.MONTH_OCTOBER:
            return "MONTH_OCTOBER";
        case exports.Month.MONTH_NOVEMBER:
            return "MONTH_NOVEMBER";
        case exports.Month.MONTH_DECEMBER:
            return "MONTH_DECEMBER";
        case exports.Month.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.monthToJSON = monthToJSON;
//# sourceMappingURL=month.js.map